import React from 'react';
import Barchart from '../charts/apex/Barchart';

const ApexBarChartWrapper = props => {
	const { dataField, aggregations, name } = props;
	const keys = [];
	const values = [];
	if (aggregations && aggregations[dataField] && aggregations[dataField].buckets) {
		aggregations[dataField].buckets.forEach(({ key: itemKey, doc_count }) => {
			keys.push(itemKey);
			values.push(doc_count);
		});
	}
	return (
		<Barchart
			chartOptions={{
				dataLabels: {
					enabled: false,
				},
			}}
			xAxisData={keys}
			barData={[{ name, data: values }]}
		/>
	);
};

export default ApexBarChartWrapper;
